module.exports = __webpack_public_path__ + "img/business_pay_02.4d938df5.png";